"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreezTheme = void 0;
const Color_1 = require("./Color");
const styles_1 = require("@material-ui/core/styles");
exports.TreezTheme = styles_1.createMuiTheme({
    palette: {
        primary: {
            main: Color_1.Color.GREEN_TREEZ,
        },
        secondary: {
            main: Color_1.Color.GREY_LIGHT,
        },
        error: {
            main: Color_1.Color.RED_ERROR,
        },
        warning: {
            main: Color_1.Color.ORANGE_WARN,
        },
        info: {
            main: Color_1.Color.BLUE_INFO,
        }
    }
});
exports.default = exports.TreezTheme;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGhlbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc3R5bGVzL1RoZW1lLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFnQztBQUNoQyxxREFBMEQ7QUFFN0MsUUFBQSxVQUFVLEdBQUcsdUJBQWMsQ0FBRTtJQUN0QyxPQUFPLEVBQUU7UUFDTCxPQUFPLEVBQUU7WUFDTCxJQUFJLEVBQUUsYUFBSyxDQUFDLFdBQVc7U0FDMUI7UUFDRCxTQUFTLEVBQUU7WUFDUCxJQUFJLEVBQUUsYUFBSyxDQUFDLFVBQVU7U0FDekI7UUFDRCxLQUFLLEVBQUU7WUFDSCxJQUFJLEVBQUUsYUFBSyxDQUFDLFNBQVM7U0FDeEI7UUFDRCxPQUFPLEVBQUU7WUFDTCxJQUFJLEVBQUUsYUFBSyxDQUFDLFdBQVc7U0FDMUI7UUFDRCxJQUFJLEVBQUU7WUFDRixJQUFJLEVBQUUsYUFBSyxDQUFDLFNBQVM7U0FDeEI7S0FDSjtDQUNKLENBQUMsQ0FBQztBQUVILGtCQUFlLGtCQUFVLENBQUMifQ==